import { bucketName } from "@utils/baseValues";

export const convertS3UrlToHttps = (objectKey: string) => {
  return `https://${bucketName}.s3.eu-central-1.amazonaws.com/${objectKey}`;
};
